export default "__VITE_ASSET__ZEJa5sqo__"